<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="header accent-700 p-24">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <div class="contact-name mt-8">Mensagem</div>
            <button mat-icon-button (click)="dimiss()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>


    <div mat-dialog-content class="p-12 pb-5 m-0" fxLayout="column" fxLayoutGap="10">
        
        <div fxLayout="row">
            <mat-form-field appearance="outline" class="w-40-p mr-12">
                <mat-label>Grupo para mensagem</mat-label>
                <input placeholder="Grupo para mensagem" matInput [matAutocomplete]="autoPerformerF" autocomplete="off"
                    type="search" [formControl]="roleControl" />
                    <mat-error *ngIf="roleControl.hasError('incorrect')">
                        Grupo inválido
                    </mat-error>
                <mat-autocomplete autoActiveFirstOption #autoPerformerF="matAutocomplete" autoActiveFirstOption
                    [displayWith]="displaySimpleFn">
                    <mat-option *ngFor="let role of roleList" [value]="role">
            
                        <p>
                            {{ role.name }}
                        </p>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <button *ngIf="professionalId != null" mat-stroked-button class="button-default" fxFlex="40" color="primary" (click)="setRoleDefault()">Definir grupo como padrão</button>

        </div>

        <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Mensagem</mat-label>
            <textarea placeholder="mensagem" id="dialog-plan-name_plan" matInput name="name" cwgAutoFocusDirective [formControl]="messageControl"
            rows="4" ></textarea>
        </mat-form-field>


        <button mat-stroked-button fxFlex="100" color="primary" (click)="sendMessage()" [disabled]="isSending">Enviar mensagem</button>
    </div>

</div>